import {
  generateItemsReducer,

  generateItemAndActionsFromStore,
  generateItemListAndActionsFromStore,
} from "./item";

const itemType = "documentActivity";
const endpoint = "document_activities/";

export const documentActivitiesReducer = generateItemsReducer<DocumentActivitySnakeModel, {}>(itemType);

export const documentActivityAndActionsFromStore = generateItemAndActionsFromStore<DocumentActivitySnakeModel, {}, {}>(
  itemType,
  endpoint,
  (a, b, c, d) => ({}),
);

export const documentActivityListAndActionsFromStore = generateItemListAndActionsFromStore(itemType, documentActivityAndActionsFromStore);
